import moment from "moment";

import { firebaseDb } from "../../firebase";
import * as actionTypes from "./actionTypes";

export const captureEventStart = () => {
  return {
    type: actionTypes.CAPTURE_START,
  };
};

export const captureEventSuccess = () => {
  return {
    type: actionTypes.CAPTURE_SUCCESS,
    success: true,
  };
};

export const captureEventFinish = () => {
  return {
    type: actionTypes.CAPTURE_FINISH,
    success: false,
  };
};

export const captureEventFail = (error) => {
  return {
    type: actionTypes.CAPTURE_FAIL,
    error: error,
  };
};

export const saveStravaEvent = (capturedEvent, selectedEvent) => {
  return (dispatch) => {
    dispatch(captureEventStart());
    console.log("capturedStravaEvent", capturedEvent);
    // Add a new document in collection "cities"
    firebaseDb
      .collection("User_Event")
      .doc()
      .set({
        userId: capturedEvent.item.user.userId,
        firstName: capturedEvent.item.user.firstName,
        lastName: capturedEvent.item.user.lastName,
        time: capturedEvent.item.eventTime,
        distance: capturedEvent.item.distance,
        eventId: capturedEvent.item.event.eventId,
        eventFlyer: capturedEvent.item.event.data.imageSource,
        eventName: capturedEvent.item.event.data.name,
      })
      .then(function () {
        console.log("Document successfully written!");
        dispatch(captureEventSuccess());
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  };
};

export const saveCapturedEvent = (capturedEvent) => {
  return (dispatch) => {
    dispatch(captureEventStart());
    console.log("capturedEvent", capturedEvent);
    
    firebaseDb
      .collection("User_Event")
      .doc()
      .set({
        userId: capturedEvent.item.user.userId,
        firstName: capturedEvent.item.user.firstName,
        lastName: capturedEvent.item.user.lastName,
        time: moment(capturedEvent.item.eventTime).format("HH:mm:ss"),
        distance: capturedEvent.item.distance,
        eventId: capturedEvent.item.event.eventId,
        eventFlyer: capturedEvent.item.event.data.imageSource,
        eventName: capturedEvent.item.event.data.name,
      })
      .then(function () {
        console.log("Document successfully written!");
        dispatch(captureEventSuccess());
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  };
};
